import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { BrandMark } from "./ui-kit";
import { SignOut } from "@phosphor-icons/react";

export default function MobileHeader({ title, action, transparent = false }) {
  const { logout } = useAuth();
  return (
    <header
      className={`mobile-header-safe sticky top-0 z-[800] grid grid-cols-[minmax(0,1fr)_auto] items-center gap-2 px-4 pb-3 ${
        transparent ? "bg-transparent" : "bg-background/80 backdrop-blur-xl"
      }`}
      data-testid="mobile-header"
    >
      {title ? (
        <div className="mobile-header-brand flex min-w-0 items-center gap-2">
          <Link to="/" className="min-w-0 flex-1 overflow-hidden" data-testid="brand-link"><BrandMark /></Link>
          <span className="mobile-header-title-pill shrink-0 rounded-full border border-white/10 bg-white/5 px-2 py-1 text-[10px] font-bold uppercase tracking-widest text-muted-foreground">
            {title}
          </span>
        </div>
      ) : (
        <Link to="/" className="mobile-header-brand block" data-testid="brand-link"><BrandMark /></Link>
      )}
      <div className="mobile-header-actions flex items-center justify-end gap-2">
        {action}
        <button
          onClick={logout}
          className="rounded-full border border-white/10 bg-white/5 p-2 press-down hover:bg-white/10"
          data-testid="logout-button"
          title="Déconnexion"
        >
          <SignOut size={18} weight="bold" />
        </button>
      </div>
    </header>
  );
}
